import React, { Component } from "react";
import http from "@/http"
import { Divider } from "antd";
import styles from "../../overview/device/deviceInfo/components/defaultStatus.module.less";
import DefaultStatus from "../../overview/device/deviceInfo/components/DefaultStatus";
import CONST from "@/dataSource/CONST"
const { YingshiProduct } = CONST

class AlarmDevice extends Component {
    state = {
        deviceInfo: {},
        refreshKey: 0,
    }

    componentDidMount() {
        const { deviceId } = this.props
        this.getDeviceDetail(deviceId)
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { deviceId } = this.props
        if (deviceId !== prevProps.deviceId)
            this.getDeviceDetail(deviceId)
    }
    getDeviceDetail = (id) => {
        http.tokiot.device.get({ id, allShadowProp: true })
            .then(ret => {
                ret && this.setState({ deviceInfo: ret, refreshKey: this.state.refreshKey + 1 })
            })
    }

    get isVideo() {
        const { deviceInfo } = this.state;
        let productId = deviceInfo ? deviceInfo.productId : ``;
        return YingshiProduct[productId];
    }

    render() {
        const { deviceId } = this.props
        const { deviceInfo, refreshKey } = this.state
        return (
            <DefaultStatus refreshKey={refreshKey} key={deviceId} deviceInfo={deviceInfo} isVideo={this.isVideo} />
        )
    }
}

export default AlarmDevice;